
export const localeData: Record<string, Record<string, string>> = {

};
